(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-box"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const forms = document.querySelectorAll('.klaviyo-newsletter-form');

    forms.forEach(function (form) {
      const emailInput = form.querySelector('.newsletter-email-input');
      const submitBtn = form.querySelector('.newsletter-submit-btn');
      const container = form.closest('.newsletter-shadow');
      const contentDiv = container.querySelector('.newsletter-content');
      const successDiv = container.querySelector('.newsletter-success');

      // Change submit button color when user types
      emailInput.addEventListener('input', function () {
        if (emailInput.value.trim().length > 0) {
          submitBtn.classList.remove('text-light-grey');
          submitBtn.classList.add('text-black');
        } else {
          submitBtn.classList.remove('text-black');
          submitBtn.classList.add('text-light-grey');
        }
      });

      form.addEventListener('submit', async function (e) {
        e.preventDefault();

        const emailInput = form.querySelector('.newsletter-email-input');
        const submitBtn = form.querySelector('.newsletter-submit-btn');
        const submitText = submitBtn.querySelector('.submit-text');
        const loadingText = submitBtn.querySelector('.loading-text');
        const messageDiv = form.querySelector('.newsletter-message');
        const listId = form.dataset.klaviyoListId;

        const email = emailInput.value.trim();

        if (!email) {
          showMessage(messageDiv, 'Please enter a valid email address.', 'error');
          return;
        }

        // Disable button during submission
        submitBtn.disabled = true;
        submitText.style.display = 'none';
        loadingText.style.display = 'inline';

        try {
          // Subscribe to Klaviyo list using the public client API
          const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=TBpTJS`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              revision: '2024-07-15',
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Newsletter Signup',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email,
                      },
                    },
                  },
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: listId,
                    },
                  },
                },
              },
            }),
          });

          if (response.ok || response.status === 202 || response.status === 201) {
            showSuccessState(contentDiv, successDiv);
          } else {
            const errorData = await response.json();
            showMessage(messageDiv, 'Something went wrong. Please try again.', 'error');
            console.error('Klaviyo subscription error:', errorData);
          }
        } catch (error) {
          showMessage(messageDiv, 'Something went wrong. Please try again.', 'error');
          console.error('Newsletter subscription error:', error);
        } finally {
          // Re-enable button
          submitBtn.disabled = false;
          submitText.style.display = 'inline';
          loadingText.style.display = 'none';
        }
      });
    });

    function showSuccessState(contentDiv, successDiv) {
      contentDiv.style.display = 'none';
      successDiv.style.display = 'block';
    }

    function showMessage(element, message, type) {
      element.textContent = message;
      element.style.display = 'block';
      element.style.color = type === 'success' ? '#28a745' : '#dc3545';

      setTimeout(function () {
        element.style.display = 'none';
      }, 5000);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
